import { useEffect, useRef } from "react";

// Calls `callback` every `ms` milliseconds. Always invokes the latest callback
// (via ref) so it never uses a stale closure over component state.
export function usePoll(callback, ms = 20000, enabled = true) {
  const ref = useRef(callback);
  useEffect(() => { ref.current = callback; });
  useEffect(() => {
    if (!enabled) return undefined;
    const id = setInterval(() => { if (document.visibilityState !== "hidden") ref.current && ref.current(); }, ms);
    return () => clearInterval(id);
  }, [ms, enabled]);
}
